import { ref, onMounted, watch } from 'vue'
import { usePDF } from '@tato30/vue-pdf'

export function usePdfLoader(src, emit) {
  const pdf = ref(null)
  const pages = ref(0)
  const loading = ref(true)
  const errorMessage = ref('')
  const errorMessageVisible = ref(false)
  const timeoutId = ref(null)

  const pdfData = usePDF(src)

  const startTimeout = () => {
    timeoutId.value = setTimeout(() => {
      if (loading.value && !pdf.value) {
        errorMessageVisible.value = true
        loading.value = false
        errorMessage.value = 'Documento não encontrado ou demorou muito.'
      }
    }, 10000)
  }

  const clearTimeoutFn = () => {
    if (timeoutId.value) {
      clearTimeout(timeoutId.value)
      timeoutId.value = null
    }
  }

  watch(
    () => [pdfData.pdf.value, pdfData.pages.value, pdfData.info.value],
    ([newPdf, newPages, info]) => {
      clearTimeoutFn()
      pdf.value = newPdf
      pages.value = newPages

      if (newPdf && newPages > 0) {
        loading.value = false
        errorMessageVisible.value = false
        emit?.('mounted')
        return
      }

      if (info?.error) {
        loading.value = false
        errorMessageVisible.value = true
        errorMessage.value = info.error.message || 'Erro ao carregar.'
      }
    },
    { immediate: true }
  )

  onMounted(startTimeout)

  return { pdf, pages, loading, errorMessage, errorMessageVisible }
}
